var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, Math, available, i18n, undefined) {
var displayTotal = Math.min(available, 9);
// iterate new Array(displayTotal)
;(function(){
  var $$obj = new Array(displayTotal);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var star = $$obj[i];

var dist  = Math.abs(Math.floor(displayTotal / 2) - i)
var klass = "star-delay-" + dist;
if (i < available) klass += " active";
if (available > 4) klass += " bunched";
buf.push("<div" + (jade.cls(['star',klass], [null,true])) + "></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var star = $$obj[i];

var dist  = Math.abs(Math.floor(displayTotal / 2) - i)
var klass = "star-delay-" + dist;
if (i < available) klass += " active";
if (available > 4) klass += " bunched";
buf.push("<div" + (jade.cls(['star',klass], [null,true])) + "></div>");
    }

  }
}).call(this);

buf.push("<h4 class=\"text-bold text-pre\">" + (jade.escape((jade_interp = i18n("stars.available", { smart_count: available })) == null ? '' : jade_interp)) + "</h4>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"available" in locals_for_with?locals_for_with.available:typeof available!=="undefined"?available:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}